import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as QuoteOpen } from "../../../assets/images/quote-sx.svg";
import { ReactComponent as QuoteClose } from "../../../assets/images/quote-dx.svg";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import fotoPres from "../../../assets/images/gm.png";
import firmaPres from "../../../assets/images/firma-gm.png";
import bkg from "../../../assets/images/bkg-beige.png";

export default function Sezione2popup2EN({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  // ESC + blocco scroll quando il popup è aperto
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Letters to the Stakeholders", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Letters to the Stakeholders"
    >
      <div
        className="
          relative
          bg-white shadow-2xl
          max-h-[90vh] w-full md:w-[1280px] overflow-y-auto overscroll-contain
        "
        // sfondo
        style={{ 
             backgroundImage: `url(${bkg})`,
            backgroundRepeat:'no-repeat', 
            backgroundPosition:'right bottom', 
            backgroundSize:'cover' 
        }}
      >
        {/* Azioni in alto a destra: badge, share, X */}
        <div className="absolute right-3 top-3 flex items-center gap-2 z-2">
          <button
            onClick={() => onShare("Sezione2popup2")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] hover:bg-[#fff] hover:text-white border border-transparent hover:border-[#0E3761] transition"
            title="Condividi"
            aria-label="Condividi"
          >
            {shareIcon ? <img src={shareIcon} alt="" className="h-4 w-4" /> : "↗"}
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] hover:bg-[#fff] hover:text-white border border-transparent hover:border-[#0E3761] transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            {closeIcon ? <img src={closeIcon} alt="Chiudi" className="h-4 w-4" /> : "✕"}
          </button>
        </div>

        {/* Contenuto */}
        <div className="py-8">
          <div className="flex flex-col gap-6">

            <div className="flex flex-col md:flex-row gap-4">

                <div className="md:w-1/3" style={{borderBottom:"2px solid #002655"}}>
                    <img
                        src={fotoPres}
                        alt="Autore"
                        className="w-full md:w-[245px] md:ml-auto pb-3"
                    />
                </div>

                <div className="md:w-2/3 relative flex items-center flex-wrap px-5 md:pr-8">
                    <QuoteOpen className="mt-1 w-6 h-6 absolute top-1 md:top-6" />
                    <div>
                      <p className="pl-0 md:pl-6 pt-12 text-[16px] md:text-[24px]">
                        Dear Stakeholders,
                      </p>
                      <p className="pl-0 md:pl-6 text-[16px] md:text-[24px]">
                        2024 was characterised by major political and institutional events that have strengthened our determination to continue along the
                        path laid out by our Group, driven by our Purpose “Taking care of people for a better world, together”.
                      </p>
                    </div>
                </div>

            </div>
                    
            {/* Colonna destra: testo */}
            <div className="flex flex-col relative px-5 md:px-8">              

              {/* Paragrafi */}
              <div className="mt-1 space-y-4">
                <p className="text-[16px] md:text-[24px]">
                    Today, companies are subject to innumerable pressures, which will be the challenges of the near future: environmental and social
                    pressures, the growing need for careful risk management, and the expenses triggered by regulatory compliance requirements.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    In this ever-changing scenario, companies should reflect on the strategic role to be given to sustainability matters in order to make
                    them practical and significant.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    For this reason, at Reale Group, we are working hard to take advantage of this great opportunity to create value and, to this end,
                    we are integrating sustainability into our operational, management and governance processes, and we are incorporating it into our
                    long-term strategic plans.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    In 2024, we have launched major projects and made far-reaching commitments in the area of sustainability. We are confident
                    that these will enable us to remain true to our unique positioning and to embrace change in an evolutionary way.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    I hope that the analysis of this document document will provide you with an understanding of the scale of this transformation.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    Enjoy your reading!
                </p>
                 <QuoteClose className="mt-1 w-6 h-6" />
              </div>

              {/* Firma */}
              <div className="mt-8 flex flex-col items-end justify-end gap-4">
                <div className="flex flex-col text-center">
                  <div className="font-semibold text-[#0E3761]">Luca Filippone</div>
                  <div className="text-sm text-[#0E3761]">Group &  RMA General Manager</div>
                </div>
                <img
                  src={firmaPres}
                  alt="Firma Luca Filippone"
                  className="h-12 md:h-14 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}